import http from "../lib/http";

export const getBanners = () => {
  return http.get("/api/customer/banners");
};